module.exports = __webpack_public_path__ + "static/Q9Answer_Owlways_wishmastree-caa6d565ccbab9d98238e04828339e93.jpg";